<template>
  <div>
    <div v-if="value" class="fixed top-0 left-0 z-40 w-full h-full bg-overlay" />
    <div v-if="value" class="fixed top-0 left-0 z-40 w-full h-full overflow-hidden">
      <div class="absolute top-0 left-0 flex flex-wrap items-center justify-center w-full h-full p-5 overflow-x-auto">
        <div class="relative w-full max-w-xl px-5 py-6 bg-white xl:py-10">
          <div
            v-if="dismissable"
            class="absolute top-0 right-0 p-2 mt-1 mr-1 cursor-pointer"
            @click="$emit('input', false)"
          >
            <img src="~images/psp/close.svg" class="w-3 h-3 xl:w-4 xl:h-4">
          </div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Modal from '~brand-components/base/modal/modal.ts'

export default Modal.extend()
</script>
